import { ControlBar, useRoomContext } from "@livekit/components-react"
import { useNavigation, useRoute } from "@react-navigation/native"
import moment from "moment"
import React from "react"
import { useWindowDimensions, View } from "react-native"
import { ActivityIndicator, Portal } from "react-native-paper"
import { useSafeAreaFrame, useSafeAreaInsets } from "react-native-safe-area-context"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { apiIdle, apiRequest } from "../../../data/redux/actions/api"
import { setIsLiveModeEnabled } from "../../../data/redux/actions/liveMode"
import { liveService } from "../../../data/services/liveService"
import { liveServiceV2 } from "../../../data/services/liveServiceV2"
import { hasRole } from "../../../data/utility/ability"
import { numberToWords } from "../../../data/utility/dataUtils"
import { hasFeature } from "../../../data/utility/Utils"
import { findClosestNextOccurrence } from "../../../student/account/onboarding/LiveRoomCard"
import { DialogM } from "../../components/alert/dialog/Dialog"
import AvatarGroupM from "../../components/avatar/AvatarGroupM"
import TouchableRippleM from "../../components/button/TouchableRippleM"
import { Menu3Point } from "../../components/menu/Menu3Point"
import { CustomIconButton } from "../../header/LiveModeFooter"
import LiveSessionDialogComponent from "../../header/LiveSessionDialogComponent"
import { satisfactionDialogTitle, shouldAskSatisfactionOnLeave } from "../../liveMode/leaveLiveSatisfaction"
import LiveHelpModal from "../../liveMode/LiveHelpModal"
import TroubleshootingPanel, { PROBLEMS } from "../../liveMode/TroubleshootingPanel"
import { useTroubleshootingDetection } from "../../hooks/livekit/useTroubleshootingDetection"
import { useSwitchCamera } from "../../hooks/livekit/useSwitchCamera"
import { useApiStatus } from "../../hooks/useApiStatus"
import { useCurrentActivity } from "../../hooks/useCurrentActivity"
import useLiveChatUserId from "../../hooks/useLiveChatUserId"
import { hasValueGreaterThanZero } from "../../liveMode/LiveChat"
import { theme } from "../../theme/theme"
import { IS_WEB } from "../../utils/mobileUtils"
import DraggableView from "../../video-call/DraggableView"
import { ControlBarM } from "./ControlBarM"
import useThrottledSetAttributes from "../../../engine/live/room/useThrottledSetAttributes"

const onExitPress = (action1) => {
    const standardTitle = "Veux-tu vraiment quitter ?"
    const standardButton1 = "Quitter le LIVE"

    const studentTitle = standardTitle
    const studentButton1 = standardButton1

    const title = studentTitle
    const button1 = studentButton1

    DialogM.show({
        champion: "zoe",
        variant: "main",
        text1: title,
        buttonText1: button1,
        buttonColor1: theme.colors.primary,
        onPress: action1,
        buttonText2: "Annuler",
        buttonColor2: theme.colors.primary,
        exitButton: true,
    })
}


const StudentControlBar = (props) => {
    const {
        suspended = false,
        miniMode,
        setMiniMode,
        setFocusedMode,
        bgColor,
        isSoundMode,
        onOffCam = () => {},
        nav,
        style,
    } = props
    const insets = useSafeAreaInsets()

    const navigation = nav ?? useNavigation()
    let route = props.route ?? useRoute()

    const { width: windowWidth, height: windowHeight } = IS_WEB ? useWindowDimensions() : useSafeAreaFrame()

    const safeHeight = windowHeight - insets.top - insets.bottom
    const safeWidth = windowWidth - insets.left - insets.right

    const contentWidth = Math.min(350, safeWidth)

    const smallMode = safeWidth < 500
    const verySmallMode = safeWidth < 370

    const centerX = safeWidth / 2 - contentWidth / 2

    const liveSession = props.currentLiveSession

    const isInSilentMode =
        !props.soundModeParticipants?.includes(props.user?.id) &&
        hasRole(props.user, "student")
    const isV4 = hasFeature(liveSession?.live_room, "checkpoint-rh")

    const isHandRaised = props.raisedHands?.includes(props.user?.id)

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null

    const { setCurrentActivity, getCurrentActivity } = useCurrentActivity()
    const currentActivity = getCurrentActivity()

    useApiStatus(liveService.raiseHand, false, true, () => {})

    useApiStatus(
        liveService.sendSatisfaction,
        null,
        true,
        () => {},
        () => {}
    )

    const { setLiveChatUserId } = useLiveChatUserId(navigation, route)

    const liveStudents = liveSession?.users?.filter(
        (user) => !user?.is_tutor && props.liveParticipants?.includes(user?.id)
    )

    const raiseHandApi = liveServiceV2.raiseHandV2

    const room = useRoomContext()
    const setAttributesThrottled = useThrottledSetAttributes()

    const hasActivity = currentActivity?.progressStatus === "none"

    const {
        micWarning,
        camWarning,
        detectedProblem,
        micLevel,
        permissionsGranted,
        requestPermissions,
        showHelpModal,
        setShowHelpModal,
        showTroubleshootingPanel,
        setShowTroubleshootingPanel,
        troubleshootInitialProblem,
        openTroubleshooting,
    } = useTroubleshootingDetection({ isSoundMode: !isInSilentMode })

    const renderContent = () => {
        // Student controls
        const onMessagesPress = () => {
            // setFocusedMode(false)
            // setMiniMode(true)
            setLiveChatUserId(liveSession?.tutor?.id)
        }

        const exit = () => {
            setCurrentActivity(null, true)
            if (hasRole(props.user, "tutor"))
                props.apiRequest(liveService.leaveLiveSession, {
                    id: props.liveSessionId,
                })
            if (hasRole(props.user, "student"))
                if (shouldAskSatisfactionOnLeave(liveMoment)) {
                    setTimeout(() => {
                        DialogM.show({
                            text1: satisfactionDialogTitle(props.currentLiveSession),
                            component: (
                                <LiveSessionDialogComponent
                                    navigation={navigation}
                                    liveSessionId={props.liveSessionId}
                                />
                            ),
                            hideButton1: true,
                            buttonText2: "Pas maintenant",
                            onPressBack: () => {
                                props.apiRequest(liveService.leaveLiveSession, {
                                    id: props.liveSessionId,
                                })
                            },
                            exitButton: true,
                        })
                    }, 200)
                } else {
                    props.apiRequest(liveService.leaveLiveSession, {
                        id: props.liveSessionId,
                    })
                }
        }



        return (
            <>
                <View
                style={{
                    width: windowWidth < 700 ? safeWidth : null,
                    height: 70,
                    flexDirection: "row",
                    alignSelf: "center",
                    justifyContent: windowWidth < 700 ? "center" : "space-evenly",
                    alignItems: "center",
                    zIndex: 8,
                    ...(bgColor && {
                        backgroundColor: bgColor,
                    }),
                    ...style,
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 1,
                        ...(verySmallMode && { transform: [{ scale: 0.95 }] }),
                    }}
                >
                    <ControlBarM
                        miniMode={miniMode}
                        isSoundMode={isSoundMode}
                        onOffCam={onOffCam}
                        width={null}
                        smallMode={smallMode}
                        skipAudioRenderer
                        micWarning={micWarning}
                        camWarning={camWarning}
                        onMicWarningPress={() => openTroubleshooting(PROBLEMS.MIC_NOT_WORKING)}
                        onCamWarningPress={() => openTroubleshooting(PROBLEMS.CAMERA_NOT_WORKING)}
                        onOpenHelp={() => openTroubleshooting(detectedProblem)}
                    />

                    <CustomIconButton
                        icon="hand-paper"
                        iconColor={
                            isHandRaised
                                ? theme.colors.accent
                                : theme.colors.primary
                        }
                        containerColor={
                            isHandRaised
                                ? theme.colors.primary
                                : theme.colors.lighter
                        }
                        disabled={props.createConversationRequest}
                        badgeCount={hasValueGreaterThanZero(
                            props.raisedHands?.length
                        )}
                        onPress={() => {
                            setAttributesThrottled({
                                raise_hand_source: "",
                                display_name: props.user?.display_name,
                                skip_checkpoint: hasActivity ? "1" : "0",
                            }).catch((e) => console.error("Error setting attributes", e))
                            props.apiRequest(
                                raiseHandApi,
                                { id: props.liveSessionId },
                                { raised: !isHandRaised }
                            )
                        }}
                        loading={
                            props.raiseHandV2Request ||
                            props.createConversationRequest
                        }
                    />

                    <CustomIconButton
                        icon="comments"
                        iconColor={theme.colors.primary}
                        containerColor={theme.colors.lighter}
                        disabled={false}
                        badgeCount={
                            (liveSession?.unread_private_messages_count
                                ? Object.values(
                                    liveSession?.unread_private_messages_count
                                ).reduce(
                                    (sum, count) => sum + (count || 0),
                                    0
                                )
                                : 0) +
                            (liveSession?.unread_messages_count || 0)
                        }
                        onPress={onMessagesPress}
                    />

                    {smallMode ? (
                        <Menu3Point
                            customButtonComponent={
                                <View
                                    style={{
                                        backgroundColor: theme.colors.lighter,
                                        borderRadius: 20,
                                        paddingVertical: 10,
                                        paddingHorizontal: 10,
                                        marginHorizontal: 5,
                                    }}
                                >
                                    <FontAwesome5
                                        name="ellipsis-v"
                                        size={20}
                                        color={theme.colors.primary}
                                    />
                                </View>
                            }
                            menuItems={[
                                {
                                    icon: "stethoscope",
                                    title: "Un problème ?",
                                    onPress: () => openTroubleshooting(detectedProblem),
                                },
                            ]}
                            optionStyle={{ width: 200 }}
                        />
                    ) : (
                        <CustomIconButton
                            icon="stethoscope"
                            iconColor={theme.colors.primary}
                            containerColor={theme.colors.lighter}
                            badgeCount={detectedProblem ? 1 : 0}
                            onPress={() => openTroubleshooting(detectedProblem)}
                        />
                    )}

                    <TouchableRippleM
                        onPress={() => {
                            // setFocusedMode(false)
                            // setMiniMode(true)
                            onExitPress(exit)
                        }}
                        style={{
                            alignItems: "center",
                            justifyContent: "center",
                            alignSelf: "center",
                            height: 44,
                            width: 70,
                            backgroundColor: theme.colors.error,
                            borderRadius: 20,
                            marginHorizontal: 5,
                            opacity: props.leaveLiveSessionRequest ? 0.5 : 1,
                        }}
                        disabled={props.leaveLiveSessionRequest}
                    >
                        {props.leaveLiveSessionRequest ? (
                            <ActivityIndicator
                                color={theme.colors.white}
                                small
                            />
                        ) : (
                            <FontAwesome5
                                name="phone"
                                size={24}
                                color={theme.colors.white}
                                style={{
                                    transform: [
                                        {
                                            rotate: "225deg",
                                        },
                                    ],
                                }}
                            />
                        )}
                    </TouchableRippleM>
                </View>
            </View>
                <TroubleshootingPanel
                    visible={showTroubleshootingPanel}
                    onDismiss={() => setShowTroubleshootingPanel(false)}
                    isSoundMode={!isInSilentMode}
                    initialProblem={troubleshootInitialProblem}
                    micLevel={micLevel}
                    permissionsGranted={permissionsGranted}
                    requestPermissions={requestPermissions}
                    onRaiseHand={() => {
                        setShowTroubleshootingPanel(false)
                        setAttributesThrottled({
                            raise_hand_source: "",
                            display_name: props.user?.display_name,
                            skip_checkpoint: hasActivity ? "1" : "0",
                        }).catch((e) => console.error("Error setting attributes", e))
                        props.apiRequest(
                            raiseHandApi,
                            { id: props.liveSessionId },
                            { raised: !isHandRaised }
                        )
                    }}
                    onOpenChat={() => {
                        setShowTroubleshootingPanel(false)
                        setLiveChatUserId(liveSession?.tutor?.id)
                    }}
                    onOpenReport={() => {
                        setShowTroubleshootingPanel(false)
                        setTimeout(() => setShowHelpModal(true), 300)
                    }}
                />
                <LiveHelpModal
                    visible={showHelpModal}
                    onDismiss={() => setShowHelpModal(false)}
                    liveSessionId={props.liveSessionId}
                />
                </>
        )
    }

    return miniMode ? (
        <Portal>
            <DraggableView
                initValue={{
                    x: centerX,
                    y: safeHeight - 100,
                }}
                style={{
                    position: "absolute",
                    marginTop: insets.top,
                    marginBottom: insets.bottom,
                    marginLeft: insets.left,
                    marginRight: insets.right,
                    borderRadius: 16,
                }}
                contentHeight={suspended ? 0 : safeHeight}
                contentWidth={suspended ? 0 : contentWidth}
                maxHeight={safeHeight}
                maxWidth={safeWidth}
                isDraggable={false}
                onlyFirstDrag={true}
            >
                {renderContent()}
            </DraggableView>
        </Portal>
    ) : (
        renderContent()
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        liveParticipants: state.liveMode?.liveParticipants,
        liveSessionId: state.liveMode?.liveSessionId,
        raisedHands: state.liveMode?.raisedHands,
        raiseHandV2Request: state.api.raiseHandV2?.request,
        soundModeParticipants: state.liveMode.soundModeIds,
        leaveLiveSessionRequest: state.api.leaveLiveSession?.request,
        createConversation: state.api.createConversation,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentControlBar)
